import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

interface CategoryTabsProps {
  activeSlug: string;
  onSelect: (slug: string) => void;
}

export default function CategoryTabs({ activeSlug, onSelect }: CategoryTabsProps) {
  return (
    <div className="flex items-center gap-2 overflow-x-auto pb-2 scrollbar-hide flex-wrap">
      <button
        onClick={() => onSelect('all')}
        className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
          activeSlug === 'all'
            ? 'bg-primary-500 text-white'
            : 'bg-background-100 text-foreground-600 hover:bg-background-200'
        }`}
      >
        全部
      </button>
      {categories.map((cat) => (
        <button
          key={cat.slug}
          onClick={() => onSelect(cat.slug)}
          className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
            activeSlug === cat.slug
              ? 'bg-primary-500 text-white'
              : 'bg-background-100 text-foreground-600 hover:bg-background-200'
          }`}
        >
          <i className={`${cat.icon} text-xs`}></i>
          {cat.name}
        </button>
      ))}
      <Link
        to="/category/yule-bagua"
        className="flex items-center gap-1 px-3 py-2 rounded-full text-sm text-foreground-400 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap cursor-pointer"
      >
        更多 <i className="ri-arrow-right-line text-xs"></i>
      </Link>
    </div>
  );
}